import moment from 'moment';

function saveByteArray(byte: any, type: string, fileName: string) {
  let setFileExt;
  let byteArray;
  switch (type) {
    case 'pdf':
      setFileExt = 'application/pdf';
      byteArray = byte;
      break;
    case 'excel':
      setFileExt = 'application/vnd.ms-excel';
      byteArray = new Uint8Array(byte);
      break;
    case 'word':
      setFileExt = 'application/msword';
      byteArray = new Uint8Array(byte);
      break;
    default:
      break;
  }
  const blob = new Blob([byteArray], { type: setFileExt });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${moment().format('YYYY-MM-DD hh:mm:ss')}_${fileName}`;
  link.click();
}

export default saveByteArray;
